"use client";
import * as stylex from "@stylexjs/stylex";
import * as React from "react";
import { Provider, useQuery } from "urql";
import { useImmer } from "use-immer";
import { Brick } from "@/components/Brick";
import { Masonry } from "@/components/Masonry";
import { graphql } from "@/gql";
import { urqlClient } from "@/urqlClient";
const initialVariables = {
    first: 30,
    after: null
};
const HomePageQuery = graphql(/* GraphQL */ `
  query HomePage($first: Int!, $after: String) {
    blobs(first: $first, after: $after, orderBy: { field: CREATED_AT, direction: DESC }) {
      __typename # cachekey
      pageInfo {
        __typename # cachekey
        endCursor
        hasNextPage
      }

      edges {
        __typename # cachekey
        cursor
        node {
          id
          ...BrickFragment
        }
      }
    }
  }
`);
function Page() {
    const [state, mutate] = useImmer({
        variables: initialVariables
    });
    const [result] = useQuery({
        query: HomePageQuery,
        variables: state.variables
    });
    const containerRef = React.useRef(null);
    const blobs = result.data?.blobs;
    const loadMore = React.useCallback(()=>{
        if (!blobs?.pageInfo) {
            return;
        }
        if (!blobs.pageInfo.hasNextPage) {
            return;
        }
        if (!containerRef.current) {
            return;
        }
        if (containerRef.current.getBoundingClientRect().bottom >= window.innerHeight + 600) {
            return;
        }
        requestAnimationFrame(()=>{
            mutate((draft)=>{
                draft.variables.after = blobs.edges[blobs.edges.length - 1].cursor;
            });
        });
    }, [
        blobs,
        mutate
    ]);
    React.useEffect(()=>{
        loadMore();
        window.addEventListener("scroll", loadMore, {
            passive: true
        });
        window.addEventListener("resize", loadMore, {
            passive: true
        });
        return ()=>{
            window.removeEventListener("scroll", loadMore);
            window.removeEventListener("resize", loadMore);
        };
    }, [
        loadMore
    ]);
    return <div>
      <div ref={containerRef} className="x42y017">
        <Masonry id="home">
          {result.data?.blobs?.edges?.map(({ node })=><Brick key={node.id} blob={node}/>)}
        </Masonry>
      </div>
    </div>;
}
export default (()=><Provider value={urqlClient}>
    <Page/>
  </Provider>);
